export default __webpack_public_path__ + "static/media/151-up-2.53eb28bf.png";